'use client';

import { SkeletonActiveCampaings } from '~/shared';

export function LoadingActivesCampaignsView() {
  return <SkeletonActiveCampaings animation="wave" variant="rectangular" />;
}
